import React from 'react';
import Menu from '../Home/menu';
import { Footer } from '../Home/footer';
import { BuyTicket } from '../Contact/buyTicket';
import EmailIcon from '../../Assets/images/email.png';
import PhoneIcon from '../../Assets/images/phone.png';

export const Contact = () => {
    return (
        <div>
            <Menu />
            <div className='indiaJoy__contact__wraper'>
                <div className='indiaJoy__contact'>
                    <div className='indiaJoy__contact__left'>
                        <h2>Get <br /> in <br /> touch</h2>
                        <div className='indiaJoy__contact__section'>
                            <div className='indiaJoy__contact__items1'>
                                <h3>Khaja Vali</h3>
                                <div className='indiaJoy__contact__inner'>
                                    <div className='d-flex'>
                                        <img src={EmailIcon} alt='EmailIcon' />
                                        <p>khaja@tvaga.org</p>
                                    </div>
                                    <div className='d-flex'>
                                        <img src={PhoneIcon} alt='PhoneIcon' />
                                        <p>+91 90003 29000</p>
                                    </div>
                                </div>
                            </div>
                            <div className='indiaJoy__contact__items1'>
                                <h3>Savitri Hari</h3>
                                <div className='indiaJoy__contact__inner'>
                                    <div className='d-flex'>
                                        <img src={EmailIcon} alt='EmailIcon' />
                                        <p>savitri@indiajoy.in</p>
                                    </div>
                                    <div className='d-flex'>
                                        <img src={PhoneIcon} alt='PhoneIcon' />
                                        <p>+91 63002 53002</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='indiaJoy__contact__right'>
                        <form>
                            <label>Name</label>
                            <input name='text' fname='name' placeholder='NAME' />
                            <label>E-mail</label>
                            <input name='text' fname='name' placeholder='E-MAIL' />
                            <label>Phone</label>
                            <input name='text' fname='name' placeholder='PHONE' />
                            <label>Message</label>
                            <input name='text' fname='name' placeholder='MESSAGE' />
                            <button>Submit</button>
                        </form>
                    </div>
                </div>
            </div>
            <BuyTicket />
            <Footer />
        </div>
    )
}
